<template>
    <div class="hide_scroll" style="position: relative; padding: 20px 0;">
        <div style="margin-bottom: 30px;">
            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">1. 취소 규정</div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝 예약은 트레이닝 시작일 자정까지 무료로 취소할 수 있습니다.</div>
            </div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝이 진행되는 날에는 예약 취소 시 경과 시간에 따라 환불 비율이 달라집니다.</div>
            </div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">취소 시 환불은 카드사에 따라 2~3일의 시간이 소요됩니다.</div>
            </div>
        </div>
        <div style="margin-bottom: 30px;">
            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">2. 환불이 어려운 경우</div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">당일 취소</div>
            </div>
        </div>
        <div style="">
            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">3. 정당성으로 인해 환불이 가능한 경우</div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">코치의 요청으로 트레이닝이 취소될 경우</div>
            </div>
        </div>
        <div style="line-height: 20px; font-size: 12px; color: #606060; margin-top: 20px;">판단근거 : 코치가 임의로 트레이닝을 취소하는 경우는 코치의 개인적인 사유로 인한 진행 불가 혹은 배경적 (기후, 사고, 시설 문제 등)으로 취소가 불가피한 상황이라고 판단하여 시간 경과에 관계없이 100% 환불됩니다.</div>
        <div style="margin-top: 20px">
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">인원이 부족해 취소되었을 경우</div>
            </div>
        </div>
        <div style="line-height: 20px; font-size: 12px; color: #606060; margin-top: 20px;">판단근거 : 팀원이 모이지 않아 트레이닝이 취소된 경우는 100% 환불됩니다.</div>
        <div style="margin-top: 20px">
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">코치의 태도가 불성실하거나 적극성이 없어보이는 경우 혹은 코치로부터 인격적인 피해를 받았을 경우</div>
            </div>
        </div>
        <div style="line-height: 20px; font-size: 12px; color: #606060; margin-top: 20px;">판단근거 : 폭력 발생, 심한 욕설, 협박, 과한 스킨십(터치), 정치/선동적인 언행, 시대착오적/차별적인 언행, 난폭한 코칭, 부상 유도 및 유발 등 사례에 따라 피해의 경중을 판단하여 환불 정당성을 인정합니다.</div>
        <div style="margin-top: 20px">
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">펜데믹 수준의 감염병이 발병하여 격리 조치가 권고될 경우</div>
            </div>
        </div>
        <div style="">
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">예상치 못한 기상악화(폭설, 폭우 등)으로 인해 취소될 경우</div>
            </div>
        </div>
        <div style="margin-top: 30px;">
            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">4. 환불 비율</div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝 시작 시간 48시간 전: 전액 환불</div>
            </div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝 시작 시간 24시간 전: 예약 금액의 80% 환불</div>
            </div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝 시작 시간 12시간 전: 예약 금액의 50% 환불</div>
            </div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝 시작 시간 6시간 전: 예약 금액의 10% 환불</div>
            </div>
            <div style="display: flex; gap: 8px;">
                <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                <div style="line-height: 24px; font-size: 14px; font-weight: 500">트레이닝 시작 이후: (경과 시간에 상관 없이)환불 불가</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TeamTrainingCancelNotice"
    }
</script>

<style scoped>

</style>